import styled from '@emotion/styled'
import { HTMLProps } from 'react'

interface Props extends HTMLProps<HTMLFormElement> {
  'aria-busy': boolean
}

export const Form = styled.form<Props>`
  display: flex;
  flex-direction: column;

  > label:not(:first-of-type) {
    margin-top: 24px;
  }
`
